import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setPurpose } from "../store/userSlice";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import config from "../config";
import { toast } from "react-toastify";

function Step4({ setStep }) {
  const dispatch = useDispatch();
  const axiosPrivate = useAxiosPrivate(); // Используем хук для получения axios с токеном
  const purpose = useSelector((state) => state.user.registrationData.purpose);
  const [selectedOption, setSelectedOption] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  // 🔍 ДЕБАГ
  const [debugInfo, setDebugInfo] = useState([]);
  const [showDebug, setShowDebug] = useState(true);

  const addDebug = (message, type = "info") => {
    const timestamp = new Date().toLocaleTimeString();
    setDebugInfo((prev) => [...prev, { message, type, timestamp }].slice(-10)); // Последние 10 записей
  };

  useEffect(() => {
    setSelectedOption(purpose);
  }, [purpose]);

  const handleSelect = async (optionId) => {
    dispatch(setPurpose(optionId));
    setSelectedOption(optionId);

    setIsLoading(true);
    try {
      addDebug(`Начинаем обновление цели: ${optionId}`, "info");

      // Проверяем токен
      const authState = localStorage.getItem("authState");
      if (!authState) {
        addDebug("❌ НЕТ authState в localStorage!", "error");
        throw new Error("Нет токена авторизации");
      }

      const parsed = JSON.parse(authState);
      addDebug(
        `Токен: ${parsed.auth_token ? "✅ ЕСТЬ" : "❌ НЕТ"}`,
        parsed.auth_token ? "success" : "error"
      );
      addDebug(`User ID: ${parsed.userId || "НЕТ"}`, "info");

      console.log("📤 [Step4] Обновляем цель знакомства:", optionId);

      // Обновляем цель знакомства на сервере (PUT вместо POST!)
      const response = await axiosPrivate.put(
        config.API.USERS.UPDATE_MEET_GOAL,
        {
          purpose: optionId,
        }
      );

      addDebug(`✅ Успех! Status: ${response.status}`, "success");
      console.log("✅ [Step4] Цель знакомства обновлена:", optionId);
      setTimeout(() => setStep(5), 300); // Плавный переход
    } catch (error) {
      console.error("❌ [Step4] Ошибка обновления цели:", error);
      console.error("❌ [Step4] Error response:", error.response?.data);
      console.error("❌ [Step4] Error status:", error.response?.status);

      // Детальная информация об ошибке
      addDebug(`❌ Ошибка: ${error.message}`, "error");

      if (error.response) {
        addDebug(`Status: ${error.response.status}`, "error");
        addDebug(`Data: ${JSON.stringify(error.response.data)}`, "error");
        addDebug(`URL: ${config.API.USERS.UPDATE_MEET_GOAL}`, "error");
      } else if (error.request) {
        addDebug("❌ Нет ответа от сервера", "error");
      } else {
        addDebug(`❌ Ошибка настройки: ${error.message}`, "error");
      }

      toast.error("Ошибка при обновлении данных");
      setIsLoading(false);
    }
  };

  const options = [
    {
      id: "Флирт и свидания",
      title: "Флирт и свидания",
      description: "Ходить на свидания и хорошо проводить время",
      emoji: "🔥",
    },
    {
      id: "Серьёзные отношения",
      title: "Серьёзные отношения",
      description: "Найти вторую половинку и создать счастливые отношения",
      emoji: "💍",
    },
    {
      id: "Дружеское общение",
      title: "Дружеское общение",
      description:
        "Найти друзей и знакомых, общаться и договариваться о встречах",
      emoji: "✌️",
    },
    {
      id: "Обо всём и ни о чём",
      title: "Обо всём и ни о чём",
      description: "Общаться, делиться мыслями и идеями без ограничений",
      emoji: "🥂",
    },
  ];

  return (
    <div className="flex flex-col items-center w-full px-4">
      <h1 className="font-raleway text-center font-semibold mt-6 text-white text-[20px]">
        Расскажите, для чего вы здесь
      </h1>
      <p className="font-raleway font-light mt-2 text-white text-center text-[16px]">
        Можно изменить в любой момент
      </p>
      <div className="w-full grid grid-cols-1 justify-start flex-wrap items-center gap-[16px] mt-[32px]">
        {options.map((option) => (
          <button
            type="button"
            key={option.id}
            aria-pressed={selectedOption === option.id}
            onClick={() => handleSelect(option.id)}
            className={`w-full h-[89px] rounded-[8px] flex text-left text-white cursor-pointer transition-all
              ${
                selectedOption === option.id
                  ? "bg-[#043939] border-[1.5px] border-[#a1f69e]"
                  : "bg-[#022424] border-[1px] border-[#233636]"
              }`}
          >
            <span className="flex items-center justify-center text-[32px] w-[60px] h-[89px] text-center" aria-hidden="true">
              {option.emoji}
            </span>
            <div className="flex items-center justify-center flex-col gap-[4px]">
              <span className="w-[270px] text-[18px] font-semibold">
                {option.title}
              </span>
              <span className="w-[268px] text-[14px] font-light">
                {option.description}
              </span>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}

export default Step4;
